import app from './application.json';
import errorCodesMessages from './error-codes-messages.json';
import formValidation from './form-validation.json';
import riskDisclaimer from './risk-disclaimer.json';
import uiLib from './ui-lib.json';

const translation = Object.assign(app, riskDisclaimer, errorCodesMessages, formValidation, uiLib);
export default translation;
